<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-9">
                        <div class="font-weight-bold body-1">
                            Editar Curso
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="9">
                        <v-form ref="form" @submit.prevent="save">
                            <comp-form ref="DepForm" :edit="true" @showRichChanged="(val) => this.changeButtons(val)" :values="form" @save="save" :serverErrors="serverErrors" :stepIn="step" :stepClasses="stepClasses" @tabChanged="(val) => this.test(val)" ></comp-form>
                        </v-form>
                    </v-col>
                    
                </v-row>

            </div>

            <v-row justify="center" align="end" v-if="!showRichButtons">
				<v-col cols="12" md="9" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <secondary-button :props="saveDraftBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>

            <v-row justify="center" align="end" v-if="showRichButtons">
				<v-col cols="12" md="9" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelRichBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveRichBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import DepForm from "./Form.vue";
import Object2Form from '../../../helpers/Object2Form.js';
export default {
    components: {
        'comp-form': DepForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            step: '1',
           
            stepClasses: {st1: '', st2: '', st3: '', st4: ''},
            loading: false,
            serverErrors: {},
            showRichButtons:false,
            idLesson:-1,
            indexSectionSelected: -1,
            indexLessonSelected: -1,
            form: {
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    {
                        title: '',
                        lessons: [
                            {
                                title:'',
                                type: 'LECCIÓN',
                                has_content:false,
                            }
                        ]
                    }
                ],
                list_companies:[],
                draft:0,
                image_file: [],
                update_image_file: [],
                image_url: "",
                sections_to_delete: [],
                lessons_to_delete: [],

                images_data:[
                    // {id, url}
                ]
                // _method: "POST",
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Courses",	
                block:false,
                click: () => {}
            },
            cancelRichBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "",	
                block:false,
                click: () => {this.closeRich()}
            },
            saveDraftBtnData: {
                text: "Guardar como borrador",
                icon: "mdi-content-save-outline",
                to: "",	
                block:false,
                click: ()=>{this.saveDraft()},
                loading:false
            },
            saveBtnData: {
                text: "Siguiente",
                icon: "mdi-content-save-outline",	
                click: () => {this.save(false)},
                block:false,
                loading: false,
            },
            saveRichBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.saveRich,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate()
		},
        changeButtons(value){
            console.log(value, "richhh")
            this.showRichButtons = value.showRich;
            this.idLesson = value.idLesson;
            this.indexSectionSelected = value.indexSectionSelected;
            this.indexLessonSelected = value.indexLessonSelected;

        },
        test(val){
            console.log(val);
            this.step = val+'';
            console.log(this.step);

            this.saveBtnData.text = 'Guardar';
            if(this.step == '1'){
                this.saveBtnData.text = 'Siguiente';
            }
        },

        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.course.getCourse(this.id)
			.then((response) => {
                this.form.title = response.data.title;
                this.form.brief_description = response.data.brief_description;
                this.form.duration = response.data.duration;
                this.form.summary = response.data.summary;
                this.form.description = response.data.description;
                this.form.what_you_will_learn = response.data.what_you_will_learn;
                this.form.sections =response.data.sections;
                this.form.list_companies = response.data.companies.map((x) => {
                    return {text: x.name, value: x.id}
                });
                this.form.draft = response.data.draft == true ? 1 : 0;
                this.form.image_file = [];
                this.form.image_url = response.data?.image?.url??'';

                for (let i = 0; i < this.form.sections.length; i++) {
                    this.form.sections[i]
                    for (let index = 0; index < this.form.sections[i].lessons.length; index++) {
                        this.form.sections[i].lessons[index].type = this.form.sections[i].lessons[index].content_type;
                        
                    }
                    
                }


			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},

        save(draftMode = false){
            console.log(this.step,  draftMode, "esto")
            if(this.step == '1' && draftMode == false){
                this.test(Number(2))
                return;
            }
            
            if(this.validate()){

                 if(!draftMode){
                    this.form.draft = 0;
                }
                this.setStateLoading(draftMode, true);
                this.$store.state.loading = true;
                console.log(this.form);
                
                let form = this.processRequest(this.form);
                
                this.$api.course.updateCourse(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha guardado correctamente`);
                        this.$router.push({name: 'Courses'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 400: 
                                //console.log(99, error.response);
                                if(("message" in error.response.data)){
                                    Object.keys(error.response.data.message).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.message;
                                        error.response.data.message[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.setStateLoading(draftMode, false);
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                this.setStateLoading(draftMode, false);
                this.$store.state.loading = false;
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        setStateLoading(draftMode, value){
            if(!draftMode){
                this.saveBtnData.loading = value;
            }else{
                this.saveDraftBtnData.loading = value;
            }
        },


        saveDraft(){
            this.form.draft = 1;
            this.save(true);
        },

        closeRich(restore = true){
            console.log("tunnn");

            this.$refs.DepForm.closeRichChild(restore);
            this.changeButtons({showRich: false, idLesson: -1, indexLessonSelected: -1, indexSectionSelected: -1});
        },

        processRich(){
            let lesson = this.form.sections[this.indexSectionSelected].lessons[this.indexLessonSelected];
            if (typeof lesson?.content !== "string") {
                lesson.content = JSON.stringify(lesson.content);
            }
            //remplace img
            this.form.images_data.forEach(imageInfo => {
                lesson.content = lesson.content.replaceAll(imageInfo.url, imageInfo.id);
            });

            return lesson;
        },

        saveRich(){
            console.log(this.form)

            let lesson = this.processRich();
           
            console.log(JSON.parse(lesson.content))
            this.$api.course.updateLessonBody(this.idLesson, {title: lesson.title, type: 'LECCIÓN', content: JSON.parse(lesson.content)})
                .then(() => {
                    //console.log(response)

                    this.$store.dispatch('snackbarSuccess', `Se ha guardado correctamente`);
                    // this.$router.push({name: 'Courses'});
                    this.getLessonBody();
                })
                .catch((error) => {
                    //console.log(error.response)
                    // var errors = []
                    switch(error.response.status){
                        case 400: 
                            //console.log(99, error.response);
                            // if(("message" in error.response.data)){
                            //     Object.keys(error.response.data.message).forEach((x) => {
                            //         //console.log(x);
                            //         this.serverErrors = error.response.data.message;
                            //         error.response.data.message[x].forEach((y) => {
                            //             this.serverErrors[x] = Utils.deleteWord(x,y);
                            //             errors.push(Utils.deleteWord(x,y))
                            //         })
                            //     });
                            //     this.$store.dispatch('snackbarError', errors.join('.<br>'));
                            // }
                            this.$store.dispatch('snackbarError', 'Hubo un problema');
                        break;
                        
                    }

                    
                })
                .finally(() => {
                    this.saveBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        getLessonBody(){
            this.$api.course.getCourse(this.id)
			.then((response) => {
               

                let body = response.data.sections[this.indexSectionSelected].lessons[this.indexLessonSelected];
                body['type'] = body.content_type;
                this.form.sections[this.indexSectionSelected].lessons[this.indexLessonSelected] = body;

                console.log(this.form, "form final")
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
                this.closeRich(false);
			})
        },


        processRequest(request){
            let data = JSON.parse(JSON.stringify(request));

            data.draft = data.draft.toString();

            // data.image_file = request.image_file;

             //photo_file
            if(request.image_file instanceof File){
                data.update_image_file = request.image_file;
                // data.image = 'photo';
            }else{
                delete data.image_file;
                delete data.update_image_file;
                delete data.image;
            }

            data.list_companies = [];

            request.list_companies.forEach(c => {
                data.list_companies.push({id: c.value, name:c.text})
            });

            data.description = data.brief_description;

            // delete data.sections;
            delete data.image_url;


            data.sections_to_delete = data.sections_to_delete.filter((x) => x != undefined);
            data.lessons_to_delete = data.lessons_to_delete.filter((x) => x != undefined);


            // return({title:data.title, description: data.description});
            return Object2Form.objectToFormData(data, '', [])
        }
    },
}
</script>

<style>

</style>